// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
import React from "react"
import { Button } from "react-bootstrap"
import { IcoEdit, IcoPlus } from "libs/zIcones"
import { FormContext } from "./ZForm"
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

export default function ZFormButtonSubmit() {
    return (
        <FormContext.Consumer>
            {({ formErrors, updateMode }) => (
                <Button
                    type="submit"
                    disabled={Object.keys(formErrors).length > 0}
                    className="float-end"
                    variant="success"
                >
                    {updateMode ? (
                        <>
                            <IcoEdit /> Modifier
                        </>
                    ) : (
                        <>
                            <IcoPlus /> Ajouter
                        </>
                    )}
                </Button>
            )}
        </FormContext.Consumer>
    )
}
